import { render, staticRenderFns } from "./MinRowText.vue?vue&type=template&id=16b0e3a0"
import script from "./MinRowText.vue?vue&type=script&lang=js"
export * from "./MinRowText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports